
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/converter/csv-to-yaml",
      function () {
        return require("private-next-pages/converter/csv-to-yaml.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/converter/csv-to-yaml"])
      });
    }
  